// src/pages/NotFoundPage.js
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Search } from 'lucide-react';
import { Btn } from '../components/ui';

const NotFoundPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <Helmet>
        <title>{t('notFound.meta.title')}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="text-center" data-testid="not-found-page">
        <div className="w-20 h-20 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center mx-auto mb-5">
          <Search size={32} className="text-gray-400 dark:text-gray-500" />
        </div>
        <h1 className="text-2xl font-bold mb-2 dark:text-gray-100">{t('notFound.title')}</h1>
        <p className="text-gray-500 dark:text-gray-400 mb-6 max-w-sm mx-auto">
          {t('notFound.desc')}
        </p>
        <Btn onClick={() => navigate('/')}>{t('notFound.cta')}</Btn>
      </div>
    </div>
  );
};

export default NotFoundPage;
